import { CSSProperties, forwardRef, useMemo } from 'react';

import clsx from 'clsx';

import { IImageMedia } from '~/lib/data-contract';
import { ImageMedia } from '~/shared/components/ImageMedia/ImageMedia';
import { xsCondition } from '~/theme/lib/breakpoints';

import styles from './productDetailsCarouselItem.module.css';

export type ProductDetailsCarouselItemProps = {
	image: IImageMedia;
	onClick?: () => void;
	priority?: boolean;
	className?: string;
};

const imageSizes = [`${xsCondition} 100vw`, '50vw'].join(', ');

export const ProductDetailsCarouselItem = forwardRef<HTMLDivElement, ProductDetailsCarouselItemProps>(({ image, onClick, priority, className }, ref) => {
	const imageAspect = useMemo(() => image.width / image.height, [image.width, image.height]);
	const isLandscape = imageAspect > 1;

	const styleVars = {
		'--pdci-height-xs': isLandscape ? '300px' : '420px',
		'--pdci-margin-right': isLandscape ? 'var(--spacing-07)' : '0',
	} as CSSProperties;

	return (
		<div
			className={clsx(styles.root, className)}
			ref={ref}
			onClick={onClick}
			style={styleVars}
		>
			<ImageMedia
				priority={priority}
				image={image}
				fill
				objectFit="contain"
				sizes={imageSizes}
			/>
		</div>
	);
});
